import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import {
  setAreasIds,
  setDevelopersIds,
  setOfferFilters
} from '../../../../redux/slices/offersSlice';
import CloseIcon from '../../../../new-components/svg-icons/CloseIcon';

interface ClearSelectionChipProps {
  id: string | number;
  label: string;
  filterType: string;
}

const ClearSelectionChip = ({
  id,
  label,
  filterType
}: ClearSelectionChipProps) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    if (filterType === 'offer_type') {
      dispatch(setOfferFilters(id));
    }
    if (filterType === 'Developers_Search') {
      dispatch(setDevelopersIds(id));
    }
    if (filterType === 'Areas_search') {
      dispatch(setAreasIds(id));
    }
  };

  return (
    <Container onClick={handleClick}>
      <span>{label}</span>
      <CloseIcon
        styles={{
          width: '10px',
          height: '10px',
          fill: '#B0BDCF',
          stroke: '#B0BDCF'
        }}
      />
    </Container>
  );
};

const Container = styled.div`
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px;
  border-radius: 360px;
  border: 1px solid #c6d0de;
  background: #fff;
  font-size: 14px;
  color: #1a2028;
  font-family: materialRegular;
  cursor: pointer;
`;

export default ClearSelectionChip;
